import React, { useState } from 'react';
import { Carousel, Modal,Image  } from 'antd';
import styles from './Home.module.scss'
import { homeList } from '../utils/products'
import { ExpandOutlined } from '@ant-design/icons';
import Dashboard from './Dashboard';
import ContactUs from './ContactUs';
function Home() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [thisImg, setImg] = useState('');
  const handleOpen = (img) => {
    setImg(img);
    setIsModalOpen(true);
  };
  return (
    <>

      <div className={styles.home}>
        <Modal
          open={isModalOpen}
          closeIcon={null}
          title={null}
          width={'70%'}
          footer={null}
          onCancel={() => setIsModalOpen(false)}
        >
          <img  style={{
            width: '100%',
          }} src={thisImg} />
        </Modal>
        <Carousel autoplay>
          {homeList.map(item => <div className={styles.carousel_item}>
            <img src={item.img} />
            <div className={styles.carousel_icon}>
              <ExpandOutlined onClick={() => handleOpen(item.img)} />
            </div>

            <div className={styles.carousel_title}>{item.title}</div>
          </div>
          )}
        </Carousel>
        <Dashboard />
        <ContactUs />
      </div>    </>
  );
}

export default Home;